import styled from 'styled-components';
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  IconButton,
  Box,
  DrawerProps,
} from '@mui/material';

interface StyledDrawerProps extends DrawerProps {
  width?: number;
}

export const StyledDrawer = styled(Drawer)<StyledDrawerProps>`
  width: ${({ width = 320 }) => `${width}px`};
  flex-shrink: 0;
  z-index: 1200;
  height: 100%;
  font-family: Lato, sans-serif;
  font-size: 14px;
  line-height: 1.25rem;

  & .MuiDrawer-paper {
    width: ${({ width = 320 }) => `${width}px`};
    box-sizing: border-box;
    background-color: #ffffff;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    overflow-x: hidden;
    height: 100%;
    position: relative;
    top: 0;
    z-index: 1200;
    transition: transform 0.3s ease-in-out;
    transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(-100%)')};
    font-family: Lato, sans-serif;
    font-size: 14px;
    line-height: 1.25rem;
  }
`;

export const SidebarContainer = styled(Box)`
  height: 100%;
  margin: 12px;
  overflow-y: auto;
  padding: 0;
  font-family: Lato, sans-serif;
  font-size: 14px;
  line-height: 1.25rem;
`;

export const HeaderBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
`;

export const StyledIconButton = styled(IconButton)`
  color: #063142;
`;

export const StyledList = styled(List)`
  padding: 0;
  background-color: transparent;
  width: 100%;
  font-family: Lato, sans-serif;
  font-size: 14px;
  line-height: 1.25rem;
`;

export const ItemContainer = styled(Box)<{ isExpanded: boolean; isSelected?: boolean }>`
  border-radius: 0;
  margin-bottom: 12px;
  overflow: hidden;
  width: 100%;
`;

export const StyledListItem = styled(ListItem).withConfig({
  shouldForwardProp: (prop: string): boolean => !['isExpanded', 'level', 'isSelected'].includes(prop),
})<{ level: number; isExpanded: boolean; isSelected?: boolean }>`
  display: block;
  padding: 0;
  margin: 0;
  font-family: Lato, sans-serif;
  font-style: normal;
  font-weight: 400 !important;
  font-size: 14px;
  line-height: 1.25rem;
  color: rgb(7, 49, 66);
  background-color: #f5f5f5;
  width: 100%;
  box-sizing: border-box;

  ${({ level }) =>
    level > 0 &&
    `
    padding-left: ${level * 16}px;
    width: 100%;
    `}
`;

export const NestedList = styled(List)<{ isExpanded: boolean }>`
  padding: 0;
  margin: 0;
  color: #063142;
  background-color: #f5f5f5;
  width: 100%;
  font-family: Lato, sans-serif;
  font-size: 14px;
  line-height: 1.25rem;
`;

export const StyledListItemButton = styled(ListItemButton)<{ level: number }>`
  && {
    min-height: 50px;
    padding: 4px 20px;
    border-radius: 0;
    background-color: #f5f5f5;
    width: 100%;
    box-sizing: border-box;
    font-family: Lato, sans-serif !important;
    font-size: 14px !important;
    line-height: 1.25rem !important;

    &.Mui-selected {
      background-color: #f5f5f5;
      border: 1px solid #b8d2eb;
      color: #0a3c54;
      font-weight: 600 !important;
      &:hover {
        background-color: #f5f5f5;
      }
    }

    &:hover {
      background-color: #f5f5f5;
      opacity: 0.9;
    }
  }
`;

export const StyledListItemText = styled(ListItemText)<{ level: number; isExpanded?: boolean; isSelected?: boolean }>`
  && {
    .MuiListItemText-primary {
      font-family: Lato, sans-serif !important;
      font-size: 14px !important;
      font-style: normal !important;
      font-weight: ${({ isSelected }) => (isSelected ? '600' : '500')} !important;
      line-height: 1.25rem !important;
      color: rgb(7, 49, 66) !important;
      display: block !important;
    }
  }
`;

export const ExpandIcon = styled.div<{ isExpanded?: boolean }>`
  color: #01354c;
  display: flex;
  align-items: center;
  margin-left: 4px;
`;
